/**
 * Validates objects and properties.
 */
var Validator = (function () {
    function Validator() {
    }
    return Validator;
}());
export { Validator };



//////////////////
// WEBPACK FOOTER
// ./~/aurelia-validation/dist/native-modules/validator.js
// module id = 45
// module chunks = 0